import { textureDataSources } from './enum';


const pointHitmapDownsampledPercent = 4;

export const dataTextures = {
    nodePositionTexture: {
        datasource: textureDataSources.CLIENT,
        source: 'curPoints',       //flat [x, y] per node

        // define non-default texture format
        internalFormat: 'RG32F',
        format: 'RG',
        type: 'FLOAT',
        componentsPerTexel: 2
    }
};

export const textures = {
    ...dataTextures,
    hitmap: {
        datasource: textureDataSources.CLIENT,
        width: { unit: 'percent', value: 25 },
        height: { unit: 'percent', value: 25 },
        uniforms: {
            textureScalingFactor: 25 / 100.0
        }
    },
    pointTexture: {
        datasource: textureDataSources.CLIENT,
        retina: true
    },
    steadyStateTexture: {
        datasource: textureDataSources.CLIENT,
        retina: true
    },
    pointHitmapDownsampled: {
        datasource: textureDataSources.CLIENT,
        width: { unit: 'percent', value: pointHitmapDownsampledPercent },
        height: { unit: 'percent', value: pointHitmapDownsampledPercent },
        uniforms: {
            textureScalingFactor: pointHitmapDownsampledPercent / 100.0
        }
    }
};
